module.exports = __webpack_public_path__ + "media/images/categories/R_logo_hw_darkred-8d4912c14420a026e6d884f923627d5a.png";